function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import useStyle from "./RadioButton.style";
var RadioButton = function(_param) {
    var _hasError = _param.hasError, hasError = _hasError === void 0 ? false : _hasError, _inline = _param.inline, inline = _inline === void 0 ? false : _inline, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, _required = _param.required, required = _required === void 0 ? false : _required, id = _param.id, name = _param.name, onBlur = _param.onBlur, onChange = _param.onChange, onFocus = _param.onFocus, onUpdate = _param.onUpdate, option = _param.option, testID = _param.testID, rest = _objectWithoutProperties(_param, [
        "hasError",
        "inline",
        "isRtl",
        "required",
        "id",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "onUpdate",
        "option",
        "testID"
    ]);
    var radiobutton = null;
    var ref = _slicedToArray(useState(option === null || option === void 0 ? void 0 : option.focused), 2), isFocused = ref[0], setIsFocused = ref[1];
    useEffect(function() {
        if (!radiobutton) {
            return;
        }
        if (option === null || option === void 0 ? void 0 : option.focused) {
            radiobutton.focus();
        } else {
            radiobutton.blur();
        }
    }, [
        radiobutton,
        option === null || option === void 0 ? void 0 : option.focused
    ]);
    var handleUpdate = function(event) {
        event.preventDefault();
        if (!(option === null || option === void 0 ? void 0 : option.disabled)) {
            if (radiobutton) {
                radiobutton.focus();
            }
            if (onChange) {
                onChange(event);
            }
            if (onUpdate) {
                onUpdate(option === null || option === void 0 ? void 0 : option.value, option);
            }
        }
    };
    var handleBlur = function(event) {
        setIsFocused(false);
        if (onBlur) {
            onBlur(event);
        }
    };
    var handleFocus = function(event) {
        setIsFocused(true);
        if (onFocus) {
            onFocus(event);
        }
    };
    var ref1;
    var isChecked = (ref1 = option === null || option === void 0 ? void 0 : option.checked) !== null && ref1 !== void 0 ? ref1 : false;
    var handleMouseDown = function(event) {
        if (onChange) {
            onChange(event);
        }
        if (onUpdate) {
            onUpdate(option === null || option === void 0 ? void 0 : option.value, option);
        }
    };
    var styles = useStyle({
        isChecked: isChecked,
        isFocused: isFocused,
        hasError: hasError,
        inline: inline,
        disabled: option === null || option === void 0 ? void 0 : option.disabled,
        isRtl: isRtl
    });
    var ref2, ref3, ref4, ref5, ref6;
    return _jsxs("div", _objectSpread({
        css: styles.div,
        onMouseDown: (option === null || option === void 0 ? void 0 : option.disabled) ? undefined : handleMouseDown
    }, testID && injectTestId("".concat(testID, "__div__").concat((ref2 = option === null || option === void 0 ? void 0 : option.value) !== null && ref2 !== void 0 ? ref2 : '')), {
        children: [
            _jsx("input", _objectSpread({}, rest, {
                ref: function(c) {
                    radiobutton = c;
                },
                css: styles.input,
                id: id,
                name: name,
                type: "radio",
                checked: isChecked,
                "aria-checked": isChecked,
                "aria-invalid": hasError,
                disabled: (ref3 = option === null || option === void 0 ? void 0 : option.disabled) !== null && ref3 !== void 0 ? ref3 : false,
                onBlur: handleBlur,
                onChange: (option === null || option === void 0 ? void 0 : option.disabled) ? undefined : handleUpdate,
                onFocus: handleFocus,
                required: required,
                value: (ref4 = option === null || option === void 0 ? void 0 : option.value) !== null && ref4 !== void 0 ? ref4 : ''
            }, testID && injectTestId("".concat(testID, "__").concat((ref5 = option === null || option === void 0 ? void 0 : option.value) !== null && ref5 !== void 0 ? ref5 : '')))),
            _jsx("label", {
                htmlFor: id,
                id: "".concat(id, "_label"),
                css: styles.label,
                children: (ref6 = option === null || option === void 0 ? void 0 : option.label) !== null && ref6 !== void 0 ? ref6 : option === null || option === void 0 ? void 0 : option.value
            })
        ]
    }));
};
export default RadioButton;
